module.exports = __webpack_public_path__ + "static/media/VN.4199ecae.png";